import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import MetaManager from './components/MetaManager'
import FloatingCTA from './components/FloatingCTA'

import Home from './pages/Home'
import ElArbejde from './pages/ElArbejde'
import Kabeltraek from './pages/Kabeltraek'
import Liftarbejde from './pages/Liftarbejde'
import Designerlamper from './pages/Designerlamper'
import Erhverv from './pages/Erhverv'
import OmJakob from './pages/OmJakob'
import Kontakt from './pages/Kontakt'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F2F2F0] text-[#18191D] selection:bg-[#E36C0A] selection:text-white">
      <ScrollToTop />
      <MetaManager />
      <Navbar />

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/el-arbejde" element={<ElArbejde />} />
          {/* Scrape menu alias */}
          <Route path="/almindelige-el-opgaver" element={<Navigate to="/el-arbejde" replace />} />

          <Route path="/kabeltraek" element={<Kabeltraek />} />
          {/* Scrape menu alias */}
          <Route path="/lange-kabeltraek" element={<Navigate to="/kabeltraek" replace />} />

          <Route path="/liftarbejde" element={<Liftarbejde />} />
          {/* Scrape menu alias */}
          <Route path="/lift-arbejde" element={<Navigate to="/liftarbejde" replace />} />

          <Route path="/designerlamper" element={<Designerlamper />} />
          <Route path="/erhverv" element={<Erhverv />} />
          <Route path="/om-jakob" element={<OmJakob />} />
          <Route path="/kontakt" element={<Kontakt />} />

          {/* Error pages */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
      <FloatingCTA />
    </div>
  )
}
